/* ============================================================
   10 Year Birthday Sale — bespoke landing page runtime
   Phase (date-driven) · live countdown · tier strip · accordions ·
   scratch-card easter egg (cookie-locked weighted random reward).
   ============================================================ */
(function () {
  var root = document.querySelector('.bd');
  if (!root) return;

  // ---- config from section settings (data-attrs on .bd) ----
  var SALE_START = root.dataset.saleStart || '2026-07-21T08:00:00';
  var SALE_END = root.dataset.saleEnd || '2026-07-27T23:59:59';
  // Pin to US Eastern (EDT, -04:00 in July) so the countdown is the SAME instant for every viewer, not viewer-local.
  var startMs = new Date(SALE_START + '-04:00').getTime();
  var endMs = new Date(SALE_END + '-04:00').getTime();

  // ---- phase: hype (before start) | live (during) | ended (after) ----
  var override = null; // desktop QA toggle
  function currentMode() {
    if (override) return override;
    var now = Date.now();
    if (now < startMs) return 'hype';
    if (now > endMs) return 'ended';
    return 'live';
  }
  function copyMode(mode) { return mode === 'ended' ? 'live' : mode; } // ended reuses live strings except countdown

  function applyCopy(mode) {
    var cm = copyMode(mode);
    root.querySelectorAll('[data-live]').forEach(function (el) {
      var v = el.dataset[cm];
      if (v != null) el.textContent = v;
    });
    // node-1 wishlist CTA shows only in hype
    root.querySelectorAll('[data-hype-only]').forEach(function (el) {
      el.style.display = (mode === 'hype') ? 'inline-flex' : 'none';
    });
    // countdown framing
    var tagEl = root.querySelector('[data-cd-tag]');
    var labelEl = root.querySelector('[data-cd-label]');
    var subEl = root.querySelector('[data-cd-sub]');
    if (mode === 'ended') {
      if (tagEl) tagEl.textContent = 'Sale ended';
      if (labelEl) labelEl.textContent = 'The birthday sale has ended';
      if (subEl) subEl.textContent = 'Thank you for celebrating 10 years with us — see you next time.';
    }
    // active toggle button styling
    root.querySelectorAll('[data-phase-set]').forEach(function (b) {
      b.classList.toggle('is-on', b.dataset.phaseSet === mode);
    });
  }

  // ---- countdown ----
  function pad(n) { return String(n).padStart(2, '0'); }
  function tick() {
    var mode = currentMode();
    var target = (mode === 'hype') ? startMs : endMs;
    var diff = Math.max(0, target - Date.now());
    var d = Math.floor(diff / 86400000);
    var h = Math.floor((diff % 86400000) / 3600000);
    var m = Math.floor((diff % 3600000) / 60000);
    var s = Math.floor((diff % 60000) / 1000);
    setCd('days', pad(d)); setCd('hours', pad(h)); setCd('mins', pad(m)); setCd('secs', pad(s));
  }
  function setCd(k, v) { var el = root.querySelector('[data-cd="' + k + '"]'); if (el && el.textContent !== v) el.textContent = v; }

  function render() { applyCopy(currentMode()); tick(); }

  // ---- desktop QA phase toggle ----
  root.querySelectorAll('[data-phase-set]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      override = btn.dataset.phaseSet;
      render();
    });
  });

  // ---- shop-by-discount tier strip ----
  var tiers = root.querySelectorAll('.bd-tier');
  function activate(t) { tiers.forEach(function (x) { x.classList.toggle('is-active', x === t); }); }
  tiers.forEach(function (t) {
    t.addEventListener('mouseenter', function () { activate(t); });
    t.addEventListener('click', function () { activate(t); });
    t.addEventListener('focus', function () { activate(t); });
  });

  // ---- accordions (timeline + faq): single open per group ----
  root.querySelectorAll('[data-acc-group]').forEach(function (group) {
    var rows = group.querySelectorAll('[data-acc-row]');
    rows.forEach(function (row) {
      var head = row.querySelector('[data-acc-toggle]');
      if (!head) return;
      head.addEventListener('click', function () {
        var wasOpen = row.classList.contains('is-open');
        rows.forEach(function (r) { r.classList.remove('is-open'); });
        if (!wasOpen) row.classList.add('is-open');
      });
    });
  });

  // ---- scratch-card easter egg ----
  var modal = root.querySelector('.bd-modal');
  var eggBtn = root.querySelector('.bd-egg-btn');
  var canvas = root.querySelector('.bd-scratch-canvas');
  var AMOUNTS = [5, 10, 15, 20, 25];
  var WEIGHTS = [35, 30, 20, 10, 5]; // favor smaller to protect margin (tunable)
  // Non-guessable codes (must match the Shopify discount codes from scripts/sale/setup-scratch-codes.js)
  var CODES = { 5: 'BDAY6TDWCY', 10: 'BDAYMVFS6G', 15: 'BDAY3J99XH', 20: 'BDAYYA8B65', 25: 'BDAYJG3C3M' };

  function getCookie(name) {
    return document.cookie.split('; ').reduce(function (acc, c) {
      var p = c.split('='); return p[0] === name ? decodeURIComponent(p[1]) : acc;
    }, '');
  }
  function setCookie(name, val, days) {
    var exp = new Date(Date.now() + days * 86400000).toUTCString();
    document.cookie = name + '=' + encodeURIComponent(val) + '; expires=' + exp + '; path=/; SameSite=Lax';
  }
  function pickAmount() {
    var existing = parseInt(getCookie('bday_scratch'), 10);
    if (AMOUNTS.indexOf(existing) !== -1) return existing; // locked — no re-spin
    var total = WEIGHTS.reduce(function (a, b) { return a + b; }, 0);
    var r = Math.floor((Date.now() % total)); // deterministic-ish; good enough for an egg
    r = Math.floor(Math.random() * total);
    var acc = 0, amt = AMOUNTS[0];
    for (var i = 0; i < AMOUNTS.length; i++) { acc += WEIGHTS[i]; if (r < acc) { amt = AMOUNTS[i]; break; } }
    setCookie('bday_scratch', String(amt), 30);
    return amt;
  }

  var amount = null, scratchInit = false, cleanup = null;
  function fillPrize() {
    amount = pickAmount();
    var amtEl = root.querySelector('[data-scratch-amount]');
    var codeEl = root.querySelector('[data-scratch-code]');
    if (amtEl) amtEl.textContent = '$' + amount + ' OFF';
    if (codeEl) codeEl.textContent = CODES[amount] || '';
  }
  function openModal() {
    if (!modal) return;
    fillPrize();
    modal.classList.add('is-open');
    if (eggBtn) eggBtn.classList.add('is-hidden');
    requestAnimationFrame(initScratch);
  }
  function closeModal() {
    if (cleanup) cleanup();
    scratchInit = false;
    if (canvas) canvas.classList.remove('is-cleared');
    var hint = root.querySelector('[data-scratch-hint]');
    if (hint) hint.textContent = 'Tip: drag across the gold to scratch it off.';
    if (modal) modal.classList.remove('is-open');
    if (eggBtn) eggBtn.classList.remove('is-hidden');
  }
  function reveal() {
    if (canvas) canvas.classList.add('is-cleared');
    var hint = root.querySelector('[data-scratch-hint]');
    if (hint) hint.textContent = '🎉 Use code BDAY' + amount + ' at checkout ($100+ orders). Happy birthday from us!';
  }
  function initScratch() {
    if (!canvas || scratchInit) return;
    scratchInit = true;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var w = canvas.clientWidth, h = canvas.clientHeight;
    canvas.width = w * dpr; canvas.height = h * dpr;
    var ctx = canvas.getContext('2d');
    ctx.scale(dpr, dpr);
    var g = ctx.createLinearGradient(0, 0, w, h);
    g.addColorStop(0, '#f6c945'); g.addColorStop(.5, '#ffe08a'); g.addColorStop(1, '#e0a92e');
    ctx.fillStyle = g; ctx.fillRect(0, 0, w, h);
    ctx.fillStyle = 'rgba(120,80,0,.55)'; ctx.textAlign = 'center';
    ctx.font = '700 18px "sofia-pro","Sofia Sans",sans-serif';
    ctx.fillText('Scratch to reveal your prize', w / 2, h / 2 + 6);
    ctx.font = '26px sans-serif'; ctx.fillText('🪙', w / 2, h / 2 - 24);
    var drawing = false, revealed = false;
    function pt(e) { var r = canvas.getBoundingClientRect(); var c = e.touches ? e.touches[0] : e; return { x: c.clientX - r.left, y: c.clientY - r.top }; }
    function scratch(p) { ctx.globalCompositeOperation = 'destination-out'; ctx.beginPath(); ctx.arc(p.x, p.y, 24, 0, Math.PI * 2); ctx.fill(); }
    function check() {
      var img = ctx.getImageData(0, 0, canvas.width, canvas.height).data, clear = 0, n = 0;
      for (var i = 3; i < img.length; i += 40) { n++; if (img[i] === 0) clear++; }
      if (!revealed && clear / n > 0.5) { revealed = true; reveal(); }
    }
    function down(e) { drawing = true; scratch(pt(e)); e.preventDefault(); }
    function move(e) { if (drawing) { scratch(pt(e)); e.preventDefault(); } }
    function up() { if (drawing) { drawing = false; check(); } }
    canvas.addEventListener('mousedown', down); canvas.addEventListener('mousemove', move); window.addEventListener('mouseup', up);
    canvas.addEventListener('touchstart', down, { passive: false }); canvas.addEventListener('touchmove', move, { passive: false }); window.addEventListener('touchend', up);
    cleanup = function () {
      canvas.removeEventListener('mousedown', down); canvas.removeEventListener('mousemove', move); window.removeEventListener('mouseup', up);
      canvas.removeEventListener('touchstart', down); canvas.removeEventListener('touchmove', move); window.removeEventListener('touchend', up);
    };
  }
  root.querySelectorAll('[data-open-scratch]').forEach(function (b) { b.addEventListener('click', openModal); });
  root.querySelectorAll('[data-close-scratch]').forEach(function (b) { b.addEventListener('click', closeModal); });
  if (modal) modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });

  // ---- boot ----
  render();
  setInterval(tick, 1000);
  // re-derive mode each minute so it flips at sale boundaries without a reload
  setInterval(function () { if (!override) applyCopy(currentMode()); }, 60000);
})();
